import { createSlice } from '@reduxjs/toolkit';

export const layoutSlice = createSlice({
  name: 'layout',
  initialState: {
    sidebarOpen: false,
    menuOpen: true,
  },
  reducers: {
    handleSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    handleMenuOpen: (state, action) => {
      state.menuOpen = action.payload;
    },
  },
});

export const { handleSidebarOpen, handleMenuOpen } = layoutSlice.actions;

export default layoutSlice.reducer;
